import { render, staticRenderFns } from "./DxDeleteReasonModal.vue?vue&type=template&id=6390e213"
import script from "./DxDeleteReasonModal.vue?vue&type=script&lang=ts"
export * from "./DxDeleteReasonModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports